import { useEffect, useCallback, DependencyList } from 'react'

export function useDebounceEffect(effect: () => void, deps: DependencyList, delay = 250) {
  const callback = useCallback(effect, deps)

  useEffect(() => {
    const timeout = setTimeout(callback, delay)
    return () => clearTimeout(timeout)
  }, [callback, delay])
}
